export class QueryOptions {
    page?: PageQuery = new PageQuery();
    filter?: Object;
    sort?: string;
    include?: string;
    access?: string;
    [key: string]: unknown;
}

class PageQuery {
    size?: number;
    number?: number = 0;
    [key: string]: string | number | undefined;
}

export class ListPageQuery {
    size: number;
    page: number;

    constructor(size: number, page: number) {
        this.size = size;
        this.page = page;
    }
}
